var cifCo = ["301 201", "<g fill='none'><path fill='#FCD116' d='M.5.5h300v100H.5z'/><path fill='#003893' d='M.5 100.5h300v50H.5z'/><path fill='#CE1126' d='M.5 150.5h300v50H.5z'/></g>"];

export { cifCo };

